import { AuthService } from './services/http/auth.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  {
  
  constructor(
    private authSrv: AuthService,
  ) {
    const user = this.authSrv.getSession()
    if( user && user?.session ) {
      this.authSrv.setUser( user )
    }
  }
}
